import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'moment/locale/en-gb';

// TODO: INTL SUPPORT
const DATE_FORMAT = 'dd/MM/yyyy';

export default class DatePickerSimple extends Component {
  static propTypes = {
    selected: PropTypes.object,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    showYear: PropTypes.bool,
  };

  onChange = (date) => {
    const { onChange } = this.props;
    onChange(date);
  };

  render() {
    const {
      monthsShown,
      showTime,
      dateFormat,
      shouldCloseOnSelect,
      showMonthYearPicker,
      dobReadOnly,
      isDisabled,
    } = this.props;
    return (
      <DatePicker
        disabled={dobReadOnly || isDisabled}
        monthsShown={monthsShown ? monthsShown : 2}
        className="form-control"
        placeholderText={
          dateFormat ? dateFormat.toLowerCase() : DATE_FORMAT.toLowerCase()
        }
        dateFormat={dateFormat ? dateFormat : DATE_FORMAT}
        showYearDropdown={this.props.showYear}
        showMonthDropdown={this.props.showYear}
        dropdownMode="select"
        selected={this.props.selected}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        minDate={this.props.minDate}
        maxDate={this.props.maxDate}
        showTimeSelect={showTime}
        timeFormat="HH:mm"
        shouldCloseOnSelect={shouldCloseOnSelect}
        showMonthYearPicker={showMonthYearPicker}
        onChange={::this.onChange}
      />
    );
  }
}
